import { createInitialImageProcessingState } from '../../InitialState';
import * as types from '../actions/ImageProcessingActionTypes';
import { assign } from '../../../../../shared/Assign';
import { IImage, IImageThumbnail } from '../Entities';
import * as OrderActionTypes from '../../ActionTypes';

type ImageProcessingAction = { type: string; result: any; orderId?: number };

function isResponseForAnotherOrder(state: any, action: ImageProcessingAction) {
    return (
        state.currentOrderId !== null &&
        action.orderId !== undefined &&
        action.orderId !== state.currentOrderId
    );
}

export default function imageProcessingReducer(
    state: any = createInitialImageProcessingState(),
    action: ImageProcessingAction
) {
    if (
        action.type !== types.SET_IMAGE_PROCESSING_ORDER &&
        action.type !== OrderActionTypes.RESET_ORDER_STATES &&
        isResponseForAnotherOrder(state, action)
    ) {
        return state;
    }

    let newState;
    switch (action.type) {
        case types.COMMIT_LOCAL_CATEGORY_CHANGE_IMAGE: {
            newState = assign({}, state);
            let { imageId, category } = action.result;

            if (category === 2) {
                newState.edited.extraSelected -= 1;
            } else if (category === 1) {
                newState.edited.extraSelected += 1;
            }

            newState.edited.list = newState.edited.list.map((orderRow) => {
                orderRow.thumbnails = orderRow.thumbnails.map((thumbnail: IImageThumbnail) => {
                    if (thumbnail.id === imageId) {
                        thumbnail.overrideProperties = {
                            categoryId: category
                        };
                    }

                    return thumbnail;
                });
                return orderRow;
            });
            return newState;
        }

        case types.COMMIT_LOCAL_SWAP_IMAGES_CATEGORY: {
            newState = assign({}, state);
            let { id1, category1, id2, category2 } = action.result;

            newState.edited.list = newState.edited.list.map((orderRow) => {
                orderRow.thumbnails = orderRow.thumbnails.map((thumbnail: IImageThumbnail) => {
                    if (thumbnail.id === id1) {
                        thumbnail.overrideProperties = {
                            categoryId: category2
                        };
                    } else if (thumbnail.id === id2) {
                        thumbnail.overrideProperties = {
                            categoryId: category1
                        };
                    }

                    return thumbnail;
                });

                return orderRow;
            });

            return newState;
        }

        case types.LIST_EDITED_IMAGES_SUCCESS: {
            newState = assign({}, state);
            newState.edited.list = action.result;

            if (!newState.numberOfImages) {
                newState.numberOfImages = {};
            }

            newState.numberOfImages.edited = 0;

            newState.edited.list.forEach((x) => {
                newState.numberOfImages.edited += x.thumbnails.length;
                newState.numberOfImages.edited += x.failedUploads.length;
            });

            return newState;
        }
        case types.LIST_UNEDITED_IMAGES_SUCCESS: {
            newState = assign({}, state);
            newState.unedited.list = action.result;

            if (!newState.numberOfImages) {
                newState.numberOfImages = {};
            }

            newState.numberOfImages.original = 0;

            newState.unedited.list.forEach((x) => {
                newState.numberOfImages.original += x.thumbnails.length;
                newState.numberOfImages.original += x.failedUploads.length;
            });

            return newState;
        }
        case types.GET_IMAGE_SUCCESS: {
            newState = assign({}, state);
            newState.modal.images = action.result.imageShowcaseViewModels;
            newState.modal.availableRoomTags = action.result.availableRoomTags;
            newState.modal.existingRoomTags = action.result.existingRoomTags;
            return newState;
        }
        case types.GET_NEW_IMAGE_SUCCESS: {
            newState = assign({}, state);
            newState.modal.images = action.result.imageShowcaseViewModels;

            let thumbnailToReplace = action.result.thumbnail.thumbnailIdToReplace;

            newState.edited.list = newState.edited.list.map((row) => {
                row.thumbnails = row.thumbnails.map((image: IImageThumbnail) => {
                    if (image.id === thumbnailToReplace) {
                        image = action.result.thumbnail;
                    }

                    return image;
                });
                return row;
            });
            return newState;
        }
        case types.SAVE_COMMENT_SUCCESS: {
            newState = assign({}, state);
            newState.modal.images = newState.modal.images.map((image: IImage) => {
                if (image.id === action.result.imageId) {
                    image.commentModel.comments.push(action.result);
                    image.hasComments = true;
                }
                return image;
            });

            newState.edited.list = newState.edited.list.map((row) => {
                row.thumbnails.map((image: IImageThumbnail) => {
                    if (image.id === newState.modal.images[newState.modal.images.length - 1].id) {
                        image.hasComment = true;
                    }
                    return image;
                });
                return row;
            });

            newState.unedited.list = newState.unedited.list.map((row) => {
                row.thumbnails.map((image: IImageThumbnail) => {
                    if (image.id === newState.modal.images[0].id) {
                        image.hasComment = true;
                    }
                    return image;
                });
                return row;
            });

            return newState;
        }
        case types.SAVE_NEEDS_EDITING_SUCCESS: {
            newState = assign({}, state);
            if (newState.modal.images.length > 0) {
                newState.modal.images[newState.modal.images.length - 1].needsEditing =
                    action.result.needsEditing;

                newState.edited.list = newState.edited.list.map((row) => {
                    row.thumbnails.map((image: IImageThumbnail) => {
                        if (
                            image.id === newState.modal.images[newState.modal.images.length - 1].id
                        ) {
                            image.needsEditing = action.result.needsEditing;
                        }
                        return image;
                    });
                    return row;
                });
            }
            return newState;
        }

        case types.GET_IMAGE_PROCESSING_INFO_SUCCESS: {
            newState = assign({}, state);
            newState.comments = action.result;

            if (newState.comments.orderInternalComment) {
                newState.comments.internalComment = newState.comments.orderInternalComment;
            }

            return newState;
        }

        case types.UPDATE_IMAGE_PROCESSING_COMMENT_SUCCESS: {
            newState = assign({}, state);
            newState.comments = action.result;

            if (newState.comments.orderInternalComment) {
                newState.comments.internalComment = newState.comments.orderInternalComment;
            }

            return newState;
        }

        case types.GET_CATEGORIES_SUCCESS: {
            newState = assign({}, state);
            newState.modal.categories = action.result.categories;
            newState.modal.allowChangeCategories = action.result.allowChange;
            return newState;
        }

        case types.UPDATE_CATEGORY_SUCCESS: {
            newState = assign({}, state);
            newState.photoStatus.currentStatus = action.result.currentStatus;
            newState.photoStatus.isCorrectNumberOfImages = action.result.isCorrectNumberOfImages;
            newState.photoStatus.photosInRows = action.result.photosInRows;
            newState.photoStatus.normalImagesAvailable = action.result.normalImagesAvailable;
            newState.photoStatus.hasEditCustomerImages = action.result.hasEditCustomerImages;
            newState.photoStatus.hasFlex = action.result.hasFlex;
            newState.photoStatus.canReapprove = action.result.canReapprove;
            newState.photoStatus.customerApproval = action.result.customerApproval;
            newState.photoStatus.customerApprovalDate = action.result.customerApprovalDate;
            newState.photoStatus.selectedExtraImages = action.result.selectedExtraImages;

            newState.modal.images = newState.modal.images.map((image: IImage) => {
                image.category = action.result.category;
                return image;
            });

            newState.edited.list = newState.edited.list.map((row) => {
                row.thumbnails.map((image: IImageThumbnail) => {
                    if (image.id === action.result.imageId) {
                        image.categoryId = action.result.category.value;
                    }
                    return image;
                });
                return row;
            });

            newState.unedited.list = newState.unedited.list.map((row) => {
                row.thumbnails.map((image: IImageThumbnail) => {
                    if (image.id === action.result.imageId) {
                        image.categoryId = action.result.category.value;
                    }
                    return image;
                });
                return row;
            });
            return newState;
        }

        case types.UPDATE_IMAGES_CATEGORY_SUCCESS: {
            newState = assign({}, state);
            newState.photoStatus.currentStatus = action.result.status.currentStatus;
            newState.photoStatus.isCorrectNumberOfImages =
                action.result.status.isCorrectNumberOfImages;
            newState.photoStatus.photosInRows = action.result.status.photosInRows;
            newState.photoStatus.normalImagesAvailable = action.result.status.normalImagesAvailable;
            newState.photoStatus.hasEditCustomerImages = action.result.status.hasEditCustomerImages;
            newState.photoStatus.hasFlex = action.result.status.hasFlex;
            newState.photoStatus.canReapprove = action.result.status.canReapprove;
            newState.photoStatus.customerApproval = action.result.status.customerApproval;
            newState.photoStatus.customerApprovalDate = action.result.status.customerApprovalDate;
            newState.photoStatus.selectedExtraImages = action.result.status.selectedExtraImages;

            action.result.imageIds.forEach((x) => {
                newState.edited.list = newState.edited.list.map((row) => {
                    row.thumbnails.map((image: IImageThumbnail) => {
                        if (image.id === x) {
                            image.categoryId = action.result.categoryId.value;
                        }
                        return image;
                    });
                    return row;
                });

                newState.unedited.list = newState.unedited.list.map((row) => {
                    row.thumbnails.map((image: IImageThumbnail) => {
                        if (image.id === x) {
                            image.categoryId = action.result.categoryId.value;
                        }
                        return image;
                    });
                    return row;
                });
            });
            return newState;
        }
        case types.SWAP_CATEGORIES_SUCCESS: {
            newState = assign({}, state);

            newState.edited.list[0].thumbnails.map((thumbnail) => {
                if (thumbnail.id === action.result.id1) {
                    thumbnail.categoryId = action.result.category1;
                } else if (thumbnail.id === action.result.id2) {
                    thumbnail.categoryId = action.result.category2;
                }

                return thumbnail;
            });

            return newState;
        }
        case types.UPDATE_IMAGE_FILENAME_SUCCESS: {
            newState = assign({}, state);
            newState.modal.images.map((image: IImage) => {
                return (image.filename = action.result);
            });
            return newState;
        }
        case types.SET_IMAGE_PROCESSING_ORDER: {
            newState = assign({}, state);
            newState.currentOrderId = action.orderId;
            return newState;
        }
        case types.GET_PHOTO_STATUS_SUCCESS: {
            newState = assign({}, state);
            newState.photoStatus.currentStatus = action.result.currentStatus;
            newState.photoStatus.isCorrectNumberOfImages = action.result.isCorrectNumberOfImages;
            newState.photoStatus.photosInRows = action.result.photosInRows;
            newState.photoStatus.orderRowQuantitiesInfo = action.result.orderRowQuantitiesInfo;
            newState.photoStatus.selectedExtraImages = action.result.selectedExtraImages;
            newState.photoStatus.normalImagesAvailable = action.result.normalImagesAvailable;
            newState.photoStatus.normalImageSizeSettings = action.result.normalImageSizeSettings;
            newState.photoStatus.highImageSizeSettings = action.result.highImageSizeSettings;
            newState.photoStatus.hasEditCustomerImages = action.result.hasEditCustomerImages;
            newState.photoStatus.hasFlex = action.result.hasFlex;
            newState.photoStatus.photographerIsEditor = action.result.photographerIsEditor;
            newState.photoStatus.canReapprove = action.result.canReapprove;
            newState.photoStatus.boughtExtraImages = action.result.boughtExtraImages;
            newState.photoStatus.customerApproval = action.result.customerApproval;
            newState.photoStatus.customerApprovalDate = action.result.customerApprovalDate;
            newState.isCorrectNumberOfImages = action.result.isCorrectNumberOfImages;
            newState.photoStatus.extra = action.result.extra;

            return newState;
        }
        case types.DONE_EDITING_IMAGES_SUCCESS: {
            newState = assign({}, state);
            newState.photoStatus.currentStatus = action.result.photoStatus;
            newState.imageGalleryReference = action.result.imageGalleryReference;
            return newState;
        }
        case types.CUSTOMER_APPROVE_SUCCESS: {
            newState = assign({}, state);
            newState.photoStatus.currentStatus = action.result.photoStatus;
            newState.imageGalleryReference = action.result.imageGalleryReference;
            newState.edited.extraSelected = 0;
            newState.edited.list = newState.edited.list.map((orderrow) => {
                orderrow.thumbnails = orderrow.thumbnails.map((img: IImageThumbnail) => {
                    if (img.overrideProperties) {
                        img.overrideProperties = null;
                    }
                    return img;
                });

                return orderrow;
            });
            return newState;
        }
        case types.CUSTOMER_REAPPROVE_SUCCESS: {
            newState = assign({}, state);
            newState.photoStatus.canReapprove = action.result.canReapprove;
            return newState;
        }
        case types.REDELIVER_IMAGES_SUCCESS: {
            newState = assign({}, state);
            newState.photoStatus.currentStatus = action.result.photoStatus;
            return newState;
        }

        case types.UPDATE_DELIVERY_SUCCESS:
        case types.CREATE_DELIVERY_SUCCESS:
        case types.CREATE_REDELIVERY_SUCCESS:
        case types.SCHEDULED_DELIVERY_OVERRIDDEN:
        case types.GET_DELIVERY_STATUS_FOR_ORDER_SUCCESS: {
            newState = assign({}, state);
            newState.deliveryStatus.delivered = action.result.delivered;
            newState.deliveryStatus.isDirectDelivery = action.result.isDirectDelivery;
            newState.deliveryStatus.deliveryMessage = action.result.message;
            newState.deliveryStatus.deliveryDate = action.result.date;
            newState.deliveryStatus.deliverOnlyToMail = action.result.deliverOnlyToMail;
            if (action.result.photoStatus) {
                newState.photoStatus.currentStatus = action.result.photoStatus;
            }
            return newState;
        }
        case types.GET_IMAGE_GALLERY_REFERENCE_SUCCESS: {
            newState = assign({}, state);
            newState.imageGalleryReference = action.result.imageGalleryReference;
            return newState;
        }
        case types.GET_CONTENT_PROVIDER_SUCCESS:
            newState = assign({}, state);
            newState.contentProvider = action.result.contentProvider;
            return newState;

        case types.GET_VITEC_BROKER_SYSTEM_DELIVERY_INFO_SUCCESS:
            newState = assign({}, state);
            newState.orderId = action.result.orderId;
            newState.orderApiUrl = action.result.orderApiUrl;
            newState.contentProviderValue = action.result.contentProviderValue;
            return newState;

        case types.CREATE_STITCHED_IMAGE_SUCCESS: {
            newState = assign({}, state);
            let row = newState.edited.list.filter(
                (x) => x.id === action.result.thumbnail.orderRowId
            )[0];
            row.thumbnails = [...row.thumbnails, assign({}, action.result.thumbnail)];

            row.thumbnails.sort((a, b) => {
                if (a.categoryId > b.categoryId) {
                    return 1;
                }

                if (a.categoryId === b.categoryId) {
                    return a.id - b.id;
                }

                return -1;
            });

            row.fileNames.push({
                name: action.result.fileName,
                orderRowId: action.result.thumbnail.orderRowId
            });
            newState.photoStatus.currentStatus = action.result.currentStatus;
            newState.photoStatus.isCorrectNumberOfImages = action.result.isCorrectNumberOfImages;
            newState.photoStatus.photosInRows = action.result.photosInRows;
            newState.photoStatus.canReapprove = action.result.canReapprove;
            newState.photoStatus.customerApproval = action.result.customerApproval;
            newState.photoStatus.customerApprovalDate = action.result.customerApprovalDate;
            return newState;
        }

        case types.DELETE_UNEDITED_PHOTO_SUCCESS:
            newState = assign({}, state);
            newState.unedited.list.forEach((x) => {
                let thumbnail = x.thumbnails.find((y) => y.id === action.result);
                x.thumbnails = x.thumbnails.filter((y) => y.id !== thumbnail.id);
                x.fileNames = x.fileNames.filter((y) => y.name !== thumbnail.filename);
            });

            newState.numberOfImages.original = newState.numberOfImages.original - 1;
            return newState;

        case types.DELETE_FAILED_PHOTO_SUCCESS:
            newState = assign({}, state);

            newState.unedited.list.forEach((x) => {
                let failedUpload = x.failedUploads.find(
                    (y) => y.photoUploadMetadataId === action.result
                );
                if (failedUpload) {
                    x.failedUploads = x.failedUploads.filter(
                        (y) => y.photoUploadMetadataId !== failedUpload.photoUploadMetadataId
                    );
                    x.fileNames = x.fileNames.filter((y) => y.name !== failedUpload.filename);
                }
            });

            newState.numberOfImages.original = newState.numberOfImages.original - 1;
            return newState;

        case types.PHOTOGRAPHER_APPROVED_PHOTO_ORDER_SUCCESS:
            newState = assign({}, state);
            newState.photoStatus.currentStatus = action.result;
            return newState;

        case types.DELETE_EDITED_PHOTO_SUCCESS:
            newState = assign({}, state);
            newState.photoStatus.currentStatus = action.result.currentStatus;
            newState.photoStatus.isCorrectNumberOfImages = action.result.isCorrectNumberOfImages;
            newState.photoStatus.photosInRows = action.result.photosInRows;
            newState.photoStatus.normalImagesAvailable = action.result.normalImagesAvailable;
            newState.photoStatus.hasEditCustomerImages = action.result.hasEditCustomerImages;
            newState.photoStatus.hasFlex = action.result.hasFlex;
            newState.photoStatus.canReapprove = action.result.canReapprove;
            newState.photoStatus.customerApproval = action.result.customerApproval;
            newState.photoStatus.customerApprovalDate = action.result.customerApprovalDate;

            newState.modal.images = newState.modal.images.filter(
                (x) => x.id !== action.result.photoId
            );
            return newState;

        case types.DELETE_MULTIPLE_SUCCESS:
            newState = assign({}, state);
            newState.photoStatus.currentStatus = action.result.currentStatus;
            newState.photoStatus.isCorrectNumberOfImages = action.result.isCorrectNumberOfImages;
            newState.photoStatus.photosInRows = action.result.photosInRows;
            newState.photoStatus.normalImagesAvailable = action.result.normalImagesAvailable;
            newState.photoStatus.hasEditCustomerImages = action.result.hasEditCustomerImages;
            newState.photoStatus.hasFlex = action.result.hasFlex;
            newState.photoStatus.canReapprove = action.result.canReapprove;
            newState.photoStatus.customerApproval = action.result.customerApproval;
            newState.photoStatus.customerApprovalDate = action.result.customerApprovalDate;

            return newState;

        case types.CLEAR_IMAGEPROCESSING_STATE:
            return { ...createInitialImageProcessingState(), currentOrderId: state.currentOrderId };

        case OrderActionTypes.RESET_ORDER_STATES:
            return {
                ...createInitialImageProcessingState(),
                currentOrderId: action.orderId === undefined ? null : action.orderId
            };

        case types.RESET_REJECTION_SUCCESS:
            return {
                ...state,
                photoStatus: {
                    ...state.photoStatus,
                    currentStatus: action.result
                }
            };

        case types.UPDATE_IMAGES_SORT_ORDER_INDEXES: {
            const updatedThumbnails = state.edited.list[0].thumbnails.map((thumbnail) => {
                const matchingThumbnail = action.result.find(
                    (result) => result.id === thumbnail.id
                );
                if (matchingThumbnail) {
                    return { ...thumbnail, sortIndex: matchingThumbnail.idx };
                }
                return thumbnail;
            });

            return {
                ...state,
                edited: {
                    ...state.edited,
                    list: [
                        {
                            ...state.edited.list[0],
                            thumbnails: updatedThumbnails
                        }
                    ]
                }
            };
        }

        default:
            return state;
    }
}

export let selectImageProcessing = (state) => state.imageProcessing;
export let selectEditedImages = (state) => selectImageProcessing(state).edited;
export let selectUneditedImages = (state) => selectImageProcessing(state).unedited;
